// All ISO 4217 currencies
export const CURRENCIES = [
  { code: "EUR", symbol: "€", name: "Euro" },
  { code: "USD", symbol: "$", name: "US-Dollar" },
  { code: "TND", symbol: "TND", name: "Tunesischer Dinar" },
  { code: "GBP", symbol: "£", name: "Britisches Pfund" },
  { code: "CHF", symbol: "CHF", name: "Schweizer Franken" },
  { code: "JPY", symbol: "¥", name: "Japanischer Yen" },
  { code: "CNY", symbol: "¥", name: "Chinesischer Yuan" },
  { code: "CAD", symbol: "C$", name: "Kanadischer Dollar" },
  { code: "AUD", symbol: "A$", name: "Australischer Dollar" },
  { code: "NZD", symbol: "NZ$", name: "Neuseeland-Dollar" },
  { code: "SEK", symbol: "kr", name: "Schwedische Krone" },
  { code: "NOK", symbol: "kr", name: "Norwegische Krone" },
  { code: "DKK", symbol: "kr", name: "Dänische Krone" },
  { code: "PLN", symbol: "zł", name: "Polnischer Złoty" },
  { code: "CZK", symbol: "Kč", name: "Tschechische Krone" },
  { code: "HUF", symbol: "Ft", name: "Ungarischer Forint" },
  { code: "RON", symbol: "lei", name: "Rumänischer Leu" },
  { code: "BGN", symbol: "лв", name: "Bulgarischer Lew" },
  { code: "HRK", symbol: "kn", name: "Kroatische Kuna" },
  { code: "RSD", symbol: "din", name: "Serbischer Dinar" },
  { code: "ISK", symbol: "kr", name: "Isländische Krone" },
  { code: "TRY", symbol: "₺", name: "Türkische Lira" },
  { code: "RUB", symbol: "₽", name: "Russischer Rubel" },
  { code: "UAH", symbol: "₴", name: "Ukrainische Hrywnja" },
  { code: "GEL", symbol: "₾", name: "Georgischer Lari" },
  { code: "INR", symbol: "₹", name: "Indische Rupie" },
  { code: "PKR", symbol: "₨", name: "Pakistanische Rupie" },
  { code: "BDT", symbol: "৳", name: "Bangladeschischer Taka" },
  { code: "LKR", symbol: "Rs", name: "Sri-Lanka-Rupie" },
  { code: "THB", symbol: "฿", name: "Thailändischer Baht" },
  { code: "VND", symbol: "₫", name: "Vietnamesischer Dong" },
  { code: "IDR", symbol: "Rp", name: "Indonesische Rupiah" },
  { code: "MYR", symbol: "RM", name: "Malaysischer Ringgit" },
  { code: "SGD", symbol: "S$", name: "Singapur-Dollar" },
  { code: "PHP", symbol: "₱", name: "Philippinischer Peso" },
  { code: "KRW", symbol: "₩", name: "Südkoreanischer Won" },
  { code: "TWD", symbol: "NT$", name: "Neuer Taiwan-Dollar" },
  { code: "HKD", symbol: "HK$", name: "Hongkong-Dollar" },
  { code: "BRL", symbol: "R$", name: "Brasilianischer Real" },
  { code: "MXN", symbol: "Mex$", name: "Mexikanischer Peso" },
  { code: "ARS", symbol: "$", name: "Argentinischer Peso" },
  { code: "CLP", symbol: "$", name: "Chilenischer Peso" },
  { code: "COP", symbol: "$", name: "Kolumbianischer Peso" },
  { code: "PEN", symbol: "S/", name: "Peruanischer Sol" },
  { code: "ZAR", symbol: "R", name: "Südafrikanischer Rand" },
  { code: "NGN", symbol: "₦", name: "Nigerianischer Naira" },
  { code: "GHS", symbol: "₵", name: "Ghanaischer Cedi" },
  { code: "KES", symbol: "KSh", name: "Kenianischer Schilling" },
  { code: "TZS", symbol: "TSh", name: "Tansanischer Schilling" },
  { code: "UGX", symbol: "USh", name: "Ugandischer Schilling" },
  { code: "ETB", symbol: "Br", name: "Äthiopischer Birr" },
  { code: "EGP", symbol: "E£", name: "Ägyptisches Pfund" },
  { code: "MAD", symbol: "MAD", name: "Marokkanischer Dirham" },
  { code: "DZD", symbol: "DZD", name: "Algerischer Dinar" },
  { code: "LYD", symbol: "LYD", name: "Libyscher Dinar" },
  { code: "AED", symbol: "AED", name: "VAE-Dirham" },
  { code: "SAR", symbol: "SAR", name: "Saudi-Riyal" },
  { code: "QAR", symbol: "QAR", name: "Katar-Riyal" },
  { code: "KWD", symbol: "KWD", name: "Kuwait-Dinar" },
  { code: "BHD", symbol: "BHD", name: "Bahrain-Dinar" },
  { code: "OMR", symbol: "OMR", name: "Omanischer Rial" },
  { code: "JOD", symbol: "JOD", name: "Jordanischer Dinar" },
  { code: "ILS", symbol: "₪", name: "Israelischer Schekel" },
  { code: "LBP", symbol: "LBP", name: "Libanesisches Pfund" },
  { code: "IQD", symbol: "IQD", name: "Irakischer Dinar" },
  { code: "IRR", symbol: "IRR", name: "Iranischer Rial" },
  { code: "AFN", symbol: "؋", name: "Afghanischer Afghani" },
  { code: "KZT", symbol: "₸", name: "Kasachischer Tenge" },
  { code: "UZS", symbol: "UZS", name: "Usbekischer Sum" },
  { code: "MNT", symbol: "₮", name: "Mongolischer Tögrög" },
  { code: "MMK", symbol: "K", name: "Myanmarischer Kyat" },
  { code: "KHR", symbol: "៛", name: "Kambodschanischer Riel" },
  { code: "NPR", symbol: "Rs", name: "Nepalesische Rupie" },
  { code: "CRC", symbol: "₡", name: "Costa-Rica-Colón" },
  { code: "GTQ", symbol: "Q", name: "Guatemaltekischer Quetzal" },
  { code: "DOP", symbol: "RD$", name: "Dominikanischer Peso" },
  { code: "JMD", symbol: "J$", name: "Jamaikanischer Dollar" },
  { code: "TTD", symbol: "TT$", name: "Trinidad-Dollar" },
  { code: "BOB", symbol: "Bs", name: "Bolivianischer Boliviano" },
  { code: "PYG", symbol: "₲", name: "Paraguayischer Guaraní" },
  { code: "UYU", symbol: "$U", name: "Uruguayischer Peso" },
  { code: "CDF", symbol: "FC", name: "Kongo-Franc" },
  { code: "XAF", symbol: "FCFA", name: "CFA-Franc (Zentralafrika)" },
  { code: "XOF", symbol: "CFA", name: "CFA-Franc (Westafrika)" },
  { code: "RWF", symbol: "FRw", name: "Ruandischer Franc" },
  { code: "MUR", symbol: "Rs", name: "Mauritius-Rupie" },
  { code: "SCR", symbol: "Rs", name: "Seychellen-Rupie" },
  { code: "MZN", symbol: "MT", name: "Mosambikanischer Metical" },
  { code: "BWP", symbol: "P", name: "Botswanischer Pula" },
  { code: "NAD", symbol: "N$", name: "Namibischer Dollar" },
  { code: "MWK", symbol: "MK", name: "Malawischer Kwacha" },
  { code: "ZMW", symbol: "ZK", name: "Sambischer Kwacha" },
  { code: "MDL", symbol: "L", name: "Moldauischer Leu" },
  { code: "ALL", symbol: "L", name: "Albanischer Lek" },
  { code: "MKD", symbol: "ден", name: "Nordmazedonischer Denar" },
  { code: "BAM", symbol: "KM", name: "Konvertible Mark" },
  { code: "GIP", symbol: "£", name: "Gibraltar-Pfund" },
  { code: "FJD", symbol: "FJ$", name: "Fidschi-Dollar" },
  { code: "TOP", symbol: "T$", name: "Tongaischer Paʻanga" },
  { code: "WST", symbol: "WS$", name: "Samoanischer Tala" },
  { code: "PGK", symbol: "K", name: "Papua-Neuguineischer Kina" },
  { code: "VUV", symbol: "VT", name: "Vanuatuischer Vatu" },
  { code: "SBD", symbol: "SI$", name: "Salomonen-Dollar" },
  { code: "BYN", symbol: "Br", name: "Weißrussischer Rubel" },
  { code: "AMD", symbol: "֏", name: "Armenischer Dram" },
  { code: "AZN", symbol: "₼", name: "Aserbaidschanischer Manat" },
  { code: "TJS", symbol: "SM", name: "Tadschikischer Somoni" },
  { code: "TMT", symbol: "T", name: "Turkmenischer Manat" },
  { code: "KGS", symbol: "сом", name: "Kirgisischer Som" },
  { code: "LAK", symbol: "₭", name: "Laotischer Kip" },
  { code: "BND", symbol: "B$", name: "Brunei-Dollar" },
  { code: "MOP", symbol: "MOP$", name: "Macau-Pataca" },
  { code: "CVE", symbol: "Esc", name: "Kap-Verde-Escudo" },
  { code: "STN", symbol: "Db", name: "São-Toméischer Dobra" },
  { code: "GMD", symbol: "D", name: "Gambischer Dalasi" },
  { code: "GNF", symbol: "FG", name: "Guinea-Franc" },
  { code: "SLE", symbol: "Le", name: "Sierra-Leonischer Leone" },
  { code: "LRD", symbol: "L$", name: "Liberianischer Dollar" },
  { code: "MGA", symbol: "Ar", name: "Madagassischer Ariary" },
  { code: "SOS", symbol: "Sh", name: "Somalischer Schilling" },
  { code: "DJF", symbol: "Fdj", name: "Dschibuti-Franc" },
  { code: "ERN", symbol: "Nfk", name: "Eritreischer Nakfa" },
  { code: "SDG", symbol: "SDG", name: "Sudanesisches Pfund" },
  { code: "SSP", symbol: "SSP", name: "Südsudanesisches Pfund" },
  { code: "LSL", symbol: "L", name: "Lesothischer Loti" },
  { code: "SZL", symbol: "E", name: "Swasiländischer Lilangeni" },
  { code: "MRU", symbol: "UM", name: "Mauretanischer Ouguiya" },
  { code: "MVR", symbol: "Rf", name: "Maledivische Rufiyaa" },
  { code: "BTN", symbol: "Nu", name: "Bhutanischer Ngultrum" },
  { code: "KMF", symbol: "CF", name: "Komoren-Franc" },
  { code: "HTG", symbol: "G", name: "Haitianische Gourde" },
  { code: "SRD", symbol: "SRD", name: "Surinamischer Dollar" },
  { code: "GYD", symbol: "G$", name: "Guyana-Dollar" },
  { code: "BZD", symbol: "BZ$", name: "Belize-Dollar" },
  { code: "HNL", symbol: "L", name: "Honduranischer Lempira" },
  { code: "NIO", symbol: "C$", name: "Nicaraguanischer Córdoba" },
  { code: "SVC", symbol: "₡", name: "El-Salvador-Colón" },
  { code: "BBD", symbol: "Bds$", name: "Barbados-Dollar" },
  { code: "BSD", symbol: "B$", name: "Bahama-Dollar" },
  { code: "BMD", symbol: "BD$", name: "Bermuda-Dollar" },
  { code: "KYD", symbol: "CI$", name: "Kaiman-Dollar" },
  { code: "ANG", symbol: "NAf", name: "Niederl.-Antillen-Gulden" },
  { code: "AWG", symbol: "Afl", name: "Aruba-Florin" },
  { code: "FKP", symbol: "FK£", name: "Falkland-Pfund" },
  { code: "SHP", symbol: "£", name: "St.-Helena-Pfund" },
  { code: "XCD", symbol: "EC$", name: "Ostkaribischer Dollar" },
  { code: "XPF", symbol: "F", name: "CFP-Franc" },
  { code: "CUP", symbol: "$", name: "Kubanischer Peso" },
  { code: "SYP", symbol: "£", name: "Syrisches Pfund" },
  { code: "YER", symbol: "﷼", name: "Jemenitischer Rial" },
  { code: "KPW", symbol: "₩", name: "Nordkoreanischer Won" },
  { code: "VES", symbol: "Bs.S", name: "Venezolanischer Bolívar" },
  { code: "ZWL", symbol: "Z$", name: "Simbabwe-Dollar" },
  { code: "PAB", symbol: "B/.", name: "Panamaischer Balboa" },
  { code: "BIF", symbol: "FBu", name: "Burundischer Franc" },
  { code: "AOA", symbol: "Kz", name: "Angolanischer Kwanza" },
];

// Popular currencies shown first in dropdown
export const POPULAR_CURRENCY_CODES = ["EUR", "USD", "TND", "GBP", "CHF", "CAD", "AUD", "MAD", "DZD", "SAR", "AED", "TRY"];

export const formatCurrency = (value, currency = "EUR") => {
  const safeCurrency = currency && currency.trim() ? currency.trim() : "EUR";
  if (safeCurrency === "TND") {
    return `${new Intl.NumberFormat("de-DE", { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(value)} TND`;
  }
  try {
    return new Intl.NumberFormat("de-DE", {
      style: "currency",
      currency: safeCurrency,
    }).format(value);
  } catch (e) {
    return new Intl.NumberFormat("de-DE", { style: "currency", currency: "EUR" }).format(value);
  }
};
